var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiplomBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.625 12.5H18.2656C15.3575 12.5 13 14.8575 13 17.7656V73.6406C13 76.5488 15.3575 78.9062 18.2656 78.9062H67.625C70.5331 78.9062 72.8906 76.5488 72.8906 73.6406V17.7656C72.8906 14.8575 70.5331 12.5 67.625 12.5Z",
    fill: "#CCD8E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0938 32.1562H26.7969V35.0156H59.0938V32.1562Z",
    fill: "#DFE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0938 40.2344H26.7969V43.0938H59.0938V40.2344Z",
    fill: "#DFE8F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0938 48.3125H26.7969V51.1719H59.0938V48.3125Z",
    fill: "#DFE8F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9844 56.375H26.7969V59.2344H46.9844V56.375Z",
    fill: "#DFE8F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7188 57.3281V86.3906C65.722 86.5735 65.771 86.7526 65.8614 86.9116C65.9518 87.0706 66.0805 87.2045 66.236 87.3008C66.3914 87.3972 66.5686 87.4531 66.7512 87.4633C66.9338 87.4735 67.116 87.4378 67.2812 87.3594L71.9688 84.8281C72.1302 84.7433 72.3098 84.6989 72.4922 84.6989C72.6746 84.6989 72.8542 84.7433 73.0156 84.8281L77.7031 87.3594C77.8684 87.4378 78.0506 87.4735 78.2332 87.4633C78.4158 87.4531 78.5929 87.3972 78.7484 87.3008C78.9038 87.2045 79.0326 87.0706 79.123 86.9116C79.2133 86.7526 79.2624 86.5735 79.2656 86.3906V57.3281H65.7188Z",
    fill: "#0A915A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5625 79.1875C81.0884 79.1875 88 72.2759 88 63.75C88 55.2241 81.0884 48.3125 72.5625 48.3125C64.0366 48.3125 57.125 55.2241 57.125 63.75C57.125 72.2759 64.0366 79.1875 72.5625 79.1875Z",
    fill: "#055132"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5625 72.6719C77.4899 72.6719 81.4844 68.6774 81.4844 63.75C81.4844 58.8226 77.4899 54.8281 72.5625 54.8281C67.6351 54.8281 63.6406 58.8226 63.6406 63.75C63.6406 68.6774 67.6351 72.6719 72.5625 72.6719Z",
    fill: "#0A915A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiplomBlue);
export default __webpack_public_path__ + "static/media/icon_diplom_blue.cc85ee55786604beccbc89c6da057267.svg";
export { ForwardRef as ReactComponent };